module.exports = __webpack_public_path__ + "static/media/player-left.2c3f9331.svg";